import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';

class ManualDDRows extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        console.log(typeof this.props.memberContribution.manualDdRows[0].nextPaymentDate)
        return(
            <div  style={{marginTop:"-10px", marginLeft: "10px", fontSize: "12px"}}>
                <p>{t("contribution:manualDD:part1")}<b>{t("contribution:manualDD:part2")}</b>{t("contribution:manualDD:part3")}</p>
                
    
                <table className="table-responsive superlifeLegacyPlan" style={{marginLeft: "10px", marginRight: "1px"}}>
                    <thead  style={{textAlign: "left"}}>
                        <tr>
                            <th style={{width: "45%"}}></th>
                            <th >{t("contribution:amount")}</th>
                            <th >{t("contribution:bankAccount")}</th>
                            <th >{t("contribution:scheduleDate")}</th>
                            <th >&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.memberContribution.manualDdRows.map(contribution => 
                            
                            <tr>
                                <td  style={{textAlign: "left"}}>
                                    <span>{contribution.description}</span> 
                                </td>


                                <td>
                                    <span><CurrencyFormat value={Number(contribution.amount).toFixed(2)}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'} />
                                    </span>
                                </td>
                                <td>
                                    <span>{contribution.bankAccount}</span>
                                </td>
                                <td>
                                    <span>{contribution.nextPaymentDate}</span>
                                </td>

                            </tr>
                        )}                        
                    </tbody>
                </table>
            </div>
        )
    }
}
export default withTranslation()(ManualDDRows);